import { InjectionToken } from '@angular/core';

export type CustomizationEditorSchema = Array<{
  name: string;
  variables: Array<string>;
}>;
export const CUSTOMIZATION_SCHEMA =
  new InjectionToken<CustomizationEditorSchema>('Customization Schema');
